import { LDDefaultView } from "@montana/constants/images";
import { staticSettings } from "@montana/helpers/static-settings.helper";
import { IProductImage } from "@montana/models/generated/cms.interface";
import {
    transformLDImageBackground,
    transformLDImageFrame
} from "./london-dynamics.helper";

export const getImageUrlFromProductImage = (
    productImage?: IProductImage,
    cylindoBackground?: string,
    cylindoFrame?: number
): string | undefined => {
    if (!productImage) {
        return undefined;
    }

    if (productImage.useAssetImage) {
        return productImage.assetImageViewModel?.url;
    } else if (productImage?.londonDynamicsStaticImageUrl) {
        let imageUrl = productImage.londonDynamicsStaticImageUrl;

        if (imageUrl) {
            imageUrl = cylindoBackground
                ? transformLDImageBackground(imageUrl, cylindoBackground)
                : imageUrl;
            imageUrl = cylindoFrame
                ? transformLDImageFrame(imageUrl, cylindoFrame)
                : transformLDImageFrame(imageUrl, LDDefaultView);
        }
        return imageUrl;
    }
};

export const isAnExternalLink = (url: string): boolean => {
    const regex = /(http(s?)):\/\//gi;
    return regex.test(url);
};

export const isAnAssetsLink = (url: string): boolean => {
    const regex = /^\/?assets/;
    return regex.test(url);
};

export const convertMediaUrl = (imageUrl: string | undefined): string => {
    if (!imageUrl) {
        return "";
    }

    if (isAnExternalLink(imageUrl) || isAnAssetsLink(imageUrl)) {
        return imageUrl;
    }

    if (imageUrl) {
        let returnUrl = staticSettings.apiUrl || "";

        // Append content path and image url for Episerver image requests
        if (!returnUrl.endsWith("/")) {
            returnUrl += "/";
        }

        if (!imageUrl.startsWith("/") && !returnUrl.endsWith("/")) {
            returnUrl += "/";
        }

        returnUrl += `${imageUrl.replace(/^\//g, "")}`;

        return returnUrl;
    }

    return "";
};
